import { AxiosRequestConfig } from 'axios';

import requestConfig from 'configs/requestConfig';

const api = {
  get: <T>(url: string, config?: AxiosRequestConfig): Promise<T> =>
    requestConfig.get<T>(url, config).then((response) => response.data),
  post: <T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> =>
    requestConfig.post<T>(url, data, config).then((response) => response.data),
  put: <T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> =>
    requestConfig.put<T>(url, data, config).then((response) => response.data),
  delete: <T>(url: string, config?: AxiosRequestConfig): Promise<T> =>
    requestConfig.delete<T>(url, config).then((response) => response.data),
};

export default api;
